export interface DocumentFile {
  title: string;
  url: string;
}

export interface DocumentSection {
  id?: string;
  title: string;
  files: DocumentFile[];
  sections?: DocumentSection[];
}

export const documentsData: DocumentSection = {
  title: 'Forms & Documents',
  files: [
    {
      title:
        'Electronic Funds Transfer (ETF) And Electronic Remittance Advice (ERA) Enrollment Form',
      url: 'https://framerusercontent.com/assets/HfUIU9aiwcSfQzpPxDVk7wF3I.pdf',
    },
    {
      title: 'Payer Sheet',
      url: 'https://framerusercontent.com/assets/AlcGI7Mb0oH4YfDxeOhL0X92zk8.pdf',
    },
    {
      title: 'Provider Manual',
      url: 'https://framerusercontent.com/assets/bh286TSXhF4N67PYlryLrZOuE.xlsx',
    },
    {
      title: 'Reimbursement And MAC Appeal Form',
      url: 'https://framerusercontent.com/assets/bh286TSXhF4N67PYlryLrZOuE.xlsx',
    },
  ],
  sections: [
    {
      id: 'state-specific-forms',
      title: 'State-Specific Forms & Docs',
      files: [
        {
          title: 'Arkansas: Amendment to Pharmacy Provider Manual',
          url: 'https://framerusercontent.com/assets/loxrJcSaT3dwwypwbib3bktfLY.pdf',
        },
        {
          title: 'Delaware: Amendment to Pharmacy Provider Manual',
          url: 'https://framerusercontent.com/assets/HjpMiihRYGglcXY7Oz292XcjSE.pdf',
        },
        {
          title: 'Florida: Amendment to Pharmacy Provider Manual',
          url: 'https://framerusercontent.com/assets/zcEevyyNZxYOaj05b0XJgssttQ.pdf',
        },
        {
          title: 'Kentucky: MAC Appeal Policy and Appeal Form',
          url: 'https://framerusercontent.com/assets/DMDTi7gBH6lvnsCEHItwAWbWSgs.pdf',
        },
        {
          title: 'Montana: Amendment to Pharmacy Provider Manual',
          url: 'https://framerusercontent.com/assets/IdAIQ1rousx3PGQfLwu3j0PXYs.pdf',
        },
        {
          title: 'New York: MAC Appeal Policy',
          url: 'https://framerusercontent.com/assets/Q6VVREyy0cjw7Plnaxd4lZAAAac.pdf',
        },
        {
          title: 'Tennessee: Pharmacy Reimbursement Appeal Policy',
          url: 'https://framerusercontent.com/assets/yQaxHQ0jfIiU9txHpY0OS4ZSAQ.pdf',
        },
      ],
      sections: [],
    },
    {
      id: 'state-specific-reports',
      title: 'State-Specific Reports',
      files: [
        {
          title: 'Georgia NADAC 2024 P2 May - Aug',
          url: 'https://framerusercontent.com/assets/1EOXC9SOl2B3XwP1KXKh5qvIYg.xlsx',
        },
        {
          title: 'Georgia NADAC 2024 P3 Sep - Dec',
          url: 'https://framerusercontent.com/assets/L2fcF9D0ZOUOeXwEYOmed41Aukk.xlsx',
        },
        {
          title: 'Georgia NADAC 2025 P1 Jan - Apr',
          url: 'https://framerusercontent.com/assets/ceoXRvGPKUJrpHzFpIjvLi5UxI.xlsx',
        },
        {
          title: 'Iowa NADAC Report 2025 Q4',
          url: 'https://framerusercontent.com/assets/ZiFj0Z7nNxhT6drJJv24bIRm1U.xlsx',
        },
        {
          title: 'West Virginia NADAC 2024 Q1',
          url: 'https://framerusercontent.com/assets/dGHYEMmi5wygnrQSh6gHsmr7Xc.xlsx',
        },
        {
          title: 'West Virginia NADAC 2024 Q2',
          url: 'https://framerusercontent.com/assets/l03jtKYHMEYlIz8QhV7fHaXTlA.xlsx',
        },
        {
          title: 'West Virginia NADAC 2024 Q3',
          url: 'https://framerusercontent.com/assets/RVoZAJAPIXbUCWV8wNDncjLU4M.xlsx',
        },
        {
          title: 'West Virginia NADAC 2024 Q4',
          url: 'https://framerusercontent.com/assets/QGfi5D1qnP15u3pu6vtK9x9I1U.xlsx',
        },
        {
          title: 'West Virginia NADAC 2025 Q1',
          url: 'https://framerusercontent.com/assets/FLpbZKormxkyYOZqpTw6yJo.xlsx',
        },
        {
          title: 'West Virginia NADAC 2025 Q2',
          url: 'https://framerusercontent.com/assets/JV3UPBLN7XQNK2VK9RknLlfbWc.xlsx',
        },
        {
          title: 'West Virginia NADAC 2025 Q3',
          url: 'https://framerusercontent.com/assets/z5yC6AW4O7DmemdR6tStsHjZFX8.xlsx',
        },
        {
          title: 'West Virginia NADAC 2025 Q4',
          url: 'https://framerusercontent.com/assets/bkZq95brCnoR0YXYEYM0rMazss.xlsx',
        },
      ],
      sections: [],
    },
  ],
};
